import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import './FooterIcons.style.scss';

/** @namespace Bodypwa/Component/FooterIcons/Component */
export class FooterIconsComponent extends PureComponent {
    static propTypes = {
        icons: PropTypes.arrayOf(PropTypes.shape({
            src: PropTypes.string,
            title: PropTypes.string
        })).isRequired,
        cards: PropTypes.arrayOf(PropTypes.shape({
            // eslint-disable-next-line react/forbid-prop-types
            items: PropTypes.object
        })).isRequired
    };

    renderFooterIcons() {
        const { icons = [] } = this.props;
        return icons.map((icon) => (this.renderFooterIcon(icon)));
    }

    renderFooterIcon(icon) {
        const { src, title } = icon;
        const { cards } = this.props;

        return (
            <div block="FooterIcons" elem="Inner">
                <img src={ cards.items[src] } alt={ title } block="FooterIcons" elem="Icon" />
            </div>

        );
    }

    render() {
        return (
            <div block="FooterIcons">
                <div block="FooterIcons" elem="Container">
                    { this.renderFooterIcons() }
                </div>
            </div>
        );
    }
}
export default FooterIconsComponent;
